import React, { Component, type JSX } from 'react';
import { Pagination } from './SearchBoosterPagination';
import { FilterControls } from './SearchBoosterFilterControls';
import { SearchBoosterResultsBlock } from './SearchBoosterResultsBlock';
import { SearchBoosterResultsActiveFilters } from './SearchBoosterResultsActiveFilters';
import { SearchBoosterResultsSummary } from './SearchBoosterResultsSummary';
import { events } from '../../util/Events';
import { TrainingSearchResult } from '../../models/Examentraining';
import { QueryParams } from '../../util/getQueryParams';
import { FilterOptions, SortType } from './SearchBooster';

interface ComponentProps {
  locationNotFound: boolean;
  resultGroups: TrainingSearchResult[];
  results: TrainingSearchResult[];
  filterOptions: FilterOptions;
  types: string[];
  queryParams: QueryParams;
}

interface ComponentState {
  limitBlocks: number;
  activeItem?: string;
}

/**
 * The component that handles displaying the filters, and the search results.
 * The results can either be sorted by date or by locations. When the results
 * are sorted by location, a google maps component with all locations will be
 * rendered as well. You can hover and click the markers on the map to highlight
 * or scroll to the groups of trainings.
 */
export class SearchBoosterResults extends Component<ComponentProps, ComponentState> {

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
      limitBlocks: 10,
    };

    events.on('SearchHover', (id: string) => this.setHover(id));
    events.on('SearchActive', (id: string) => this.setActive(id));
    events.on('SearchLoadMore', () => this.loadMoreLocations());
  }

  public setActive(id: string): void {
    this.setHover(id);
    this.scrollToActive(id);
  }

  /**
   * When a marker on the map gets hovered highlight
   * the related SearchResultsBlock.
   */
  public setHover(id: string): void {
    this.setState({
      activeItem: id,
    });
  }

  /**
   * Load the next few blocks.
   */
  public loadMoreLocations(): void {
    this.setState({
      limitBlocks: this.state.limitBlocks + 10,
    });
  }

  /**
   * When a market on the map gets clicked. Scroll to
   * the related SearchResultsBlock.
   */
  public scrollToActive (activeItem: string): void {
    let $el = $(`[data-id="${activeItem}"]`);

    if ($el.length) {
      $('html, body').animate({
        scrollTop: $el.offset().top - 130,
      }, 700);
    }
  }

  /**
   * Either render the NoResultsComponent or when there are trainings
   * render the list and the google maps.
   */
  public render(): JSX.Element {
    const { limitBlocks, activeItem } = this.state;
    const { locationNotFound, resultGroups, results, filterOptions, types, queryParams } = this.props;

    const visibleResults = resultGroups.slice(0, limitBlocks);

    let body = <NoExtResultsFound/>;

    if (resultGroups.length > 0) {

      body = (
        <div>
          <div className="search-results">
            <div className="flex-2">
              <div className="search-results__list">
                {visibleResults.map((result: TrainingSearchResult, key: number) => (
                  <SearchBoosterResultsBlock
                    key={key}
                    isActive={result.loc_naam === activeItem}
                    type={filterOptions.sort}
                    block={result}
                    allResults={results} />)
                )}
              </div>
            </div>
          </div>
          <Pagination totalResults={resultGroups.length}
            perPage={10}
            limitBlocks={limitBlocks}/>
        </div>
      );
    }

    return (
      <div className="container">
        <div className="search-filter__wrapper" id="search-filter">
          <FilterControls
            city={queryParams.city as string}
            filterOptions={filterOptions}
            types={types} />
        </div>
        <div className=" hidden-sm hidden-xs">
          {results.length > 0
            && <SearchBoosterResultsSummary
              city={queryParams.city as string}
              locationNotFound={locationNotFound}
              numTrainings={results.length}
              numLocations={resultGroups.length}
              type={filterOptions.sort} />
          }
        </div>
        <SearchBoosterResultsActiveFilters
          queryParams={queryParams}
          filterOptions={filterOptions}/>
        {body}
      </div>
    );
  }
}

/**
 * Render the no-trainings found message. In case there are
 * no trainings for the provided filters.
 */
export class NoExtResultsFound extends Component {
  public render(): JSX.Element {
    return (<div className="row search-results">
      <div className="col-md-12">
        <div className="search-results__list">
          <div className="search-results__item">
            Geen trainingen beschikbaar met de opgegeven criteria.<br/><br/>
            Bel voor de laatste mogelijkheden:<strong> 071 - 79 000 40</strong><br/>
          </div>
        </div>
      </div>
    </div>);
  }
}
